import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const curvy: Collection = {
  id: 'sp-curvy',
  brandId: 'sp',
  brandName: 'S|P Collection',
  icon: 'sp-collection.png',
  title: 'Curvy',
  subTitle: 'Tijdloos',
  banner: 'curvy/curvy_banner.jpg',
  items: [
    {
      id: 'sp-curvy-1',
      collectionImages: [
        {
          image: 'curvy/Curvy.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'curvy/Curvy_1.jpg',
          width: CollectionBannerWidth['66%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'sp-curvy-2',
      collectionImages: [
        {
          image: 'curvy/Curvy_3.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'curvy/Curvy_5.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'curvy/Curvy_8.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    '23fce150-7d5d-43ab-9fa3-a957255f2ad3',
    'f8087283-7443-4f94-b0b2-82b02db1a38c',
    '57d1cf77-6f2d-4c2c-983a-338f3e1fbae7',
    'c6c46081-94e3-465a-a7d0-4e3a84117c5b',
    '4019dee7-2952-4d11-9704-ccb27f9c2f62',
    'ce41ca76-23ce-41e1-80a6-1235bdf386bb',
    '65997d70-729d-40c1-ab5b-238e8fadf579',
    '632e131a-7bfb-4419-90b7-6535fe9ae5b3',
    '00076246-7c09-4891-82d9-076ab5f9ce9e'
  ]
};
